module.exports = __webpack_public_path__ + "static/img/request-a-demo.5e96889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/request-a-demo.png
// module id = MeS4
// module chunks = 0